import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import {
  ApprovalListRequestParams,
  ApprovalListResponseData,
  ApprovalHistoryRequestParams,
  ApprovalHistoryResponseData,
  ApprovalCountResponseData
} from './types'
export interface RefuseRequestParams {
  /** 审批类型: 1-外设控制, 2-敏感文件发送, 3-级联审批 */
  approval_type: number
  /** 记录ID */
  record_id: string
}
export interface RequestParams {
  /** 审批类型: 1-外设控制, 2-敏感文件发送, 3-级联审批 */
  approval_type: number
  /** 记录ID */
  record_id: string
  /** 是否同意 */
  is_agree: boolean
  /** 拒绝原因(当is_agree=false时必填) */
  reason?: string
}
export interface CancelRequestParams {
  /** 审批类型: 1-外设控制, 2-敏感文件发送, 3-级联审批 */
  approval_type: number
  /** 记录ID */
  record_id: string
}
@Injectable()
export class ApprovalListService {
  constructor (private http: Http) {}
  // 列表
  getApprovalList (data: ApprovalListRequestParams) {
    return this.http.post<ApprovalListResponseData>('/approval/list', data)
  }
  // 流转记录
  getApprovalHistory (data: ApprovalHistoryRequestParams) {
    return this.http.post<ApprovalHistoryResponseData>('/approval/history', data)
  }
  // 审批数量统计
   getApprovalPendingCount () {
    return this.http.post<ApprovalCountResponseData>('/approval/pending-count', {})
  }
  //撤回
  getApprovalCancel (data: CancelRequestParams) {
    return this.http.post<void>('/approval/cancel', data)
  }
  // 审批同意或拒绝
  getApprovalApprove (data: RequestParams) {
    return this.http.post<void>('/approval/approve', data)
  }
}
